module.exports = __webpack_public_path__ + "img/priority-low.fb1939a9.svg";